import {createSvgIcon} from '../create-svg-icon';

export const FormatQuoteIcon = createSvgIcon(
  <path d="M18.62 18h-5.24l2-4H13V6h8v7.24L18.62 18zm-2-2h.76L19 12.76V8h-4v4h3.62l-2 4zm-8 2H3.38l2-4H3V6h8v7.24L8.62 18zm-2-2h.76L9 12.76V8H5v4h3.62l-2 4z" />
, 'FormatQuoteOutlined');
